export const sharedComponents = {
  outOfStock: 'Out of Stock',
  comingSoon: 'Coming Soon',
  button: {
    cancel: 'Cancel',
    delete: 'Delete',
    remove: 'Remove'
  },
  supportCard: {
    title: 'Need help with your order?',
    description: 'To find more info',
    linkFAQ: 'visit FAQ page',
    email: 'support@athleticgreens.com',
    phone: '1-888-390-4029',
    phoneHref: '+18883904029'
  },
  paymentInfoBackGuarantee: {
    label: '90-Day Money Back Guarantee',
    description: 'If you don’t love your AG1 within the first 90 days, it’s on is.'
  },
  paymentInfoCancelAnytime: {
    label: 'Pause, Change or Cancel Anytime',
    description: 'Adjust your subscription as your needs change. You’re in control.'
  },
  promoCode: {
    promoButtonLabel: 'Apply',
    promoCTA: 'Have a promo code?',
    promoError: 'Discount code is invalid',
    promoInputLabel: 'Promo code'
  },
  summaryCheckout: {
    freePrice: 'Free',
    discountLabel: 'Your discount',
    totalLabel: 'Total',
    taxLabel: 'Tax',
    taxNotReady: '---',
    shippingLabel: 'Shipping',
    subtotalLabel: 'Subtotal',
    taxEstimatedLabel: 'Estimated Tax',
    shippingExpectedPrice: '9'
  },
  addressForm: {
    firstName: 'First Name*',
    lastName: 'Last Name*',
    country: 'Country/region*',
    addressLine1: 'Address',
    addressLine2: 'Apartment, Suite, Etc',
    city: 'City',
    province: 'State',
    zipCode: 'Zip Code',
    phone: 'Phone',
    company: 'Company',
    optional: 'optional'
  },
  // MODAL CONTENT
  editShippingAddress: {
    headerEdit: 'Edit shipping address',
    headerCreate: 'Create shipping address',
    headerSelect: 'Select Shipping Address',
    reloadMessage: 'Please, reload page',
    titleEditAddress: 'Address Info',
    usedSavedLabel: 'Use saved address',
    useSavedAddressText: 'Please choose the delivery address for your order.',
    noSavedAddressText: 'You have no saved addresses at this time',
    useSavedAddressButton: 'Use saved address',
    noSavedAddressButton: 'No saved addresses',
    defaultAddress: 'Default address:',
    defaultAddressText: 'This address is used on your subscription.',
    otherAddresses: 'Additional Addresses',
    cancelEditButton: 'Cancel',
    updateEditButton: 'Update',
    saveButton: 'Save',
    cancelSelectButton: 'Cancel',
    updateSelectButton: 'Use selected',
    submitSelectButton: 'Ok',
    massUpdate: 'Use for all active subscriptions',
    subscriptionUpdate: 'Set as the shipping address on my subscription',
    giftTitle: 'Send as a gift',
    giftRecipientEmailLabel: 'Recipient Email*',
    giftMessageLabel: 'Gift Message',
    giftAddressClosingAlert: {
      title: 'Close Recipient Shipping Address',
      content:
        'Are you sure you want to close shipping address without update? Your gift will be sent to your default address',
      editAddressButton: 'Edit address',
      confirmButton: 'Confirm'
    }
  },
  acceptDeleteAddress: {
    titleHeader: 'Delete address',
    description: 'Are you sure you are want to delete saved address',
    cancelButton: 'Cancel',
    deleteButton: 'Delete'
  },
  addressVerified: {
    title: 'Confirm Your Address',
    text: 'We couldn’t verify the exact address you entered. Please make sure it’s correct or make any necessary changes.',
    suggested: 'Suggested Address',
    entered: 'Address Entered',
    edit: 'Edit Address',
    continue: 'Save & Continue'
  },
  giftLabel: {
    short: 'Gift',
    long: 'Your Gift'
  },
  v53: {
    originalFlavorTitle: 'Original',
    upgradedFormulaText: 'UPGRADED FORMULA',
    selectFlavorText: 'Select Flavor',
    discardChanges: {
      title: 'Unsaved Changes',
      text: 'Do want to save the changes you made to your subscription?',
      save: 'Save Changes',
      discard: 'Discard Changes'
    }
  }
};
